/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDna = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m16.263 2.707 1-1L15.85.293l-1.326 1.326a5.161 5.161 0 0 0-1.48 4.354A5.158 5.158 0 0 0 8.78 7.365l-.001-.001-1.414 1.414v.001a5.158 5.158 0 0 0-1.392 4.265 5.161 5.161 0 0 0-4.353 1.48L.293 15.848l1.414 1.414 1.071-1.07 4.243 4.242-1.071 1.071 1.414 1.414 1.326-1.326a5.161 5.161 0 0 0 1.48-4.353 5.158 5.158 0 0 0 4.264-1.393v.001l1.415-1.414-.001-.001a5.158 5.158 0 0 0 1.392-4.264 5.161 5.161 0 0 0 4.354-1.48l1.326-1.326-1.414-1.414-1 1zm2.554 5.382c-.536.158-1.1.17-1.626.037a2.89 2.89 0 0 1-1.72-1.226 2.903 2.903 0 0 1-.384-.878 3.086 3.086 0 0 1 .037-1.626zm-3.616 3.505-3.582-3.582a3.07 3.07 0 0 1 1.473.005 2.89 2.89 0 0 1 1.72 1.225 2.9 2.9 0 0 1 .384.878c.12.478.123.985.005 1.474zm-1.084 1.745-.778.778-4.243-4.243.778-.778zM11.594 15.2a3.08 3.08 0 0 1-1.474-.004A2.888 2.888 0 0 1 8.4 13.97a2.902 2.902 0 0 1-.384-.878 3.078 3.078 0 0 1-.004-1.474zM8.12 18.706l-3.613-3.613a3.08 3.08 0 0 1 1.514-.005 2.89 2.89 0 0 1 1.72 1.225c.178.272.306.569.384.879a3.08 3.08 0 0 1-.005 1.514z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDna as Dna };
